var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthProvider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 4.033C3.60986 3.23166 3.93257 2.46592 4.49924 1.89924C5.06592 1.33257 5.83166 1.00986 6.633 1C7.43753 1 8.20912 1.3196 8.77801 1.88849C9.3469 2.45738 9.6665 3.22897 9.6665 4.0335C9.6665 4.83803 9.3469 5.60962 8.77801 6.17851C8.20912 6.7474 7.43753 7.067 6.633 7.067C5.83149 7.05714 5.0656 6.73429 4.4989 6.1674C3.93219 5.60051 3.6096 4.83451 3.6 4.033V4.033ZM6.633 8.8C5.4582 8.76526 4.29891 9.075 3.29799 9.69105C2.29707 10.3071 1.49826 11.2025 1 12.267V14H12.267V12.267C11.7687 11.2024 10.9697 10.3068 9.96859 9.69077C8.96747 9.07471 7.80797 8.76506 6.633 8.8V8.8Z",
    stroke: "#6E6A65",
    strokeWidth: 1.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthProvider);
export default __webpack_public_path__ + "static/media/auth-provider.svg";
export { ForwardRef as ReactComponent };